import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSunset: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSunset"><Path fillRule="evenodd" clipRule="evenodd" d="M3 13V12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12V13C15.9373 13 8.06269 13 3 13ZM1 15H23V17H1V15ZM6 19H18V21H6V19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSunset;
